
import { Tab, Tabs } from 'material-ui';

import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';


import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";

import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { withAlert } from 'react-alert';

const CustomTbodyComponent = props => (
    <div {...props} className={classNames("rt-tbody", props.className || [])}>
        <Scrollbar>{props.children}</Scrollbar>
    </div>
);


const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    smaller: {
        width: 30,
        height: 20,
    }
});

var updateTradeId = null;
var updateTradeName = null;
var SelecterSuperTradeName = null;
var SelecterSuperTradeId = null;
var isActive = null;
var isActiveSuper = null;
var serviceAddState = 0;
var serviceEditState = 0;
var serviceDeleteState = 0;
var serviceViewState = 0;

class SimpleTabbedSample extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            open: false,
            data: [],
            dataSuperTrade: [],
            dataService: [],
            dataSuperTradeService: [],
            value: 0
        };

    }

    state = {
        value: 0
    };

    handleChange = (event, value) => {
        this.setState({ value });
    };



    //////////////////////////////
    ///////Add Dialog Box State

    addhandleClickOpenService = () => {
        serviceAddState = 1;
        this.addhandleClickOpen();
    };


    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
    };

    state = {
        canSubmit: false
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    //////////////////////////////
    ///////Add Button Action Methord

    onSubmit = (model) => {

        if (serviceAddState == 1) {

            if (model.superTradeSelecter == "none") {
                this.props.alert.error("Select Super Category.");
            } else {
                this.setState({ loading: true });
                const tradeData = {
                    superTradeSelecter: model.superTradeSelecter,
                    tradeName: model.tradeName,
                    tradeRemark: model.tradeRemark,
                    isActive: 1
                }

                console.log(tradeData);

                axios.post(window.inventoryServer+'/inventory/add/tradeService', tradeData)
                    .then(response => {
                        //alert(response);
                        // alert(response['statusText']);

                        ///////////////
                        //Table Refresh
                        var dataService = [];

                        axios.get(window.inventoryServer+'/inventory/get/TradeCategoryViewService')
                            .then(response => {
                                //alert(response);
                                console.log(response.data.result);

                                var c;
                                for (c = 0; c < response.data.result.length; c++) {

                                    var activeData = response.data.result[c].IS_ACTIVE;
                                    if (activeData == 1) {
                                        activeData = 'Active';
                                    } else {
                                        activeData = 'Inactive';
                                    }


                                    dataService.push({
                                        superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                                        superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                                        tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                                        tradeName: response.data.result[c].TRADE_CATEGORY,
                                        isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                                        isActive: activeData
                                    });


                                }

                                console.log(dataService);

                                this.setState({ dataService: dataService });
                                this.setState({ loading: false });
                                //alert(response['success']);
                            }
                            );

                        if (response.data.success) {
                            this.props.alert.success("Trade Category Added Successfully.");
                        } else {
                            this.props.alert.error("Trade Category Added Error.");
                        }
                        //////////////

                        this.addhandleClose();


                    }
                    )


                serviceAddState = 0;
            }

        } else {

            if (model.superTradeSelecter == "none") {
                this.props.alert.error("Select Super Category.");
            } else {

                this.setState({ loading: true });
                const tradeData = {
                    superTradeSelecter: model.superTradeSelecter,
                    tradeName: model.tradeName,
                    tradeRemark: model.tradeRemark,
                    isActive: 1
                }

                console.log(tradeData);

                axios.post(window.inventoryServer+'/inventory/add/Trade', tradeData)
                    .then(response => {
                        //alert(response);
                        // alert(response['statusText']);

                        ///////////////
                        //Table Refresh

                        var data = [];
                        //var dataSuperTrade = [];

                        axios.get(window.inventoryServer+'/inventory/get/TradeCategoryView')
                            .then(response => {
                                //alert(response);
                                console.log(response.data.result);

                                var c;
                                for (c = 0; c < response.data.result.length; c++) {

                                    var activeData = response.data.result[c].IS_ACTIVE;
                                    if (activeData == 1) {
                                        activeData = 'Active';
                                    } else {
                                        activeData = 'Inactive';
                                    }


                                    data.push({
                                        superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                                        superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                                        tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                                        tradeName: response.data.result[c].TRADE_CATEGORY,
                                        isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                                        isActive: activeData
                                    });


                                }

                                console.log(data);

                                this.setState({ data: data });
                                this.setState({ loading: false });
                                //alert(response['success']);
                            }
                            );

                        if (response.data.success) {
                            this.props.alert.success("Trade Category Added Successfully.");
                        } else {
                            this.props.alert.error("Trade Category Added Error.");
                        }
                        //////////////

                        this.addhandleClose();


                    }
                    )
            }




        }

    };

    ////////////////////////////////////////////////////////////
    //-------------------------------------------------------

    handleClickOpenEditService = () => {
        serviceEditState = 1;
        this.handleClickOpenEdit();
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    onEdit = (model) => {

        if (serviceEditState == 1) {
            this.setState({ loading: true });
            var editTradeId = updateTradeId;
            const tradeEditData = {
                // stcId: '',
                editId: editTradeId,
                editSuperTradeId: model.superTradeSelecter,
                editName: model.editTradeName,
            }


            axios.post(window.inventoryServer+'/inventory/edit/tradeService', tradeEditData)
                .then(response => {
                    //alert(response);
                    //alert(response['statusText']);
                    //console.log(response);

                    ////////////////////////
                    /////table refresh

                    var dataService = [];

                    axios.get(window.inventoryServer+'/inventory/get/TradeCategoryViewService')
                        .then(response => {
                            //alert(response);
                            console.log(response.data.result);

                            var c;
                            for (c = 0; c < response.data.result.length; c++) {

                                var activeData = response.data.result[c].IS_ACTIVE;
                                if (activeData == 1) {
                                    activeData = 'Active';
                                } else {
                                    activeData = 'Inactive';
                                }


                                dataService.push({
                                    superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                                    superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                                    tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                                    tradeName: response.data.result[c].TRADE_CATEGORY,
                                    isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                                    isActive: activeData
                                });


                            }

                            console.log(dataService);

                            this.setState({ dataService: dataService });
                            this.setState({ loading: false });
                            //alert(response['success']);
                        }
                        );

                    if (response.data.success) {
                        this.props.alert.success("Trade Category Edit Successfully.");
                    } else {
                        this.props.alert.error("Trade Category Edit Error.");
                    }
                    ///////////////////

                }
                )

            this.handleCloseEdit();

            serviceEditState = 0;
        } else {
            this.setState({ loading: true });
            var editTradeId = updateTradeId;
            const tradeEditData = {
                // stcId: '',
                editId: editTradeId,
                editSuperTradeId: model.superTradeSelecter,
                editName: model.editTradeName,
            }


            axios.post(window.inventoryServer+'/inventory/edit/trade', tradeEditData)
                .then(response => {
                    //alert(response);
                    //alert(response['statusText']);
                    //console.log(response);

                    ////////////////////////
                    /////table refresh

                    var data = [];
                    //var dataSuperTrade = [];

                    axios.get(window.inventoryServer+'/inventory/get/TradeCategoryView')
                        .then(response => {
                            //alert(response);
                            console.log(response.data.result);

                            var c;
                            for (c = 0; c < response.data.result.length; c++) {

                                var activeData = response.data.result[c].IS_ACTIVE;
                                if (activeData == 1) {
                                    activeData = 'Active';
                                } else {
                                    activeData = 'Inactive';
                                }


                                data.push({
                                    superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                                    superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                                    tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                                    tradeName: response.data.result[c].TRADE_CATEGORY,
                                    isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                                    isActive: activeData
                                });


                            }

                            console.log(data);

                            this.setState({ data: data });
                            this.setState({ loading: false });
                            //alert(response['success']);
                        }
                        );
                    if (response.data.success) {
                        this.props.alert.success("Trade Category Edit Successfully.");
                    } else {
                        this.props.alert.error("Trade Category Edit Error.");
                    }
                    ///////////////////

                }
                )

            this.handleCloseEdit();

        }

    };

    //////////////////////////////////////////////////////////
    //------------------------------------------------------


    //////////////////////////////////////////////////////////
    //--Delete Funtion

    handleClickDeleteService = () => {
        if (isActive == 'Active') {
            this.handleClickDelete();
        } else if (isActive == 'Inactive') {
            this.handleClickDelete2();
        }
        serviceDeleteState = 1;

    };

    handleClickDelete = () => {
        this.setState({ delete: true });
    };

    handleCloseDelete2 = () => {
        this.setState({ delete2: false });
    };

    handleClickDelete2 = () => {
        this.setState({ delete2: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    stateDelete = {
        canDelete: false
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    onDelete = (tradeId, deleteTradeName, active, serviceDeleteState) => {

        if (serviceDeleteState == 1) {
            this.setState({ loading: true });

            if (active == "Active") {
                active = 0;
            } else {
                active = 1;
            }

            const tradeDeleteData = {

                deleteId: tradeId,
                deleteName: deleteTradeName,
                isActive: active,
            }

            axios.post(window.inventoryServer+'/inventory/delete/tradeService', tradeDeleteData)
                .then(response => {
                    //alert(response);
                    //alert(response['statusText']);
                    ////////////////////////
                    /////table refresh

                    var dataService = [];

                    axios.get(window.inventoryServer+'/inventory/get/TradeCategoryViewService')
                        .then(response => {
                            //alert(response);
                            console.log(response.data.result);

                            var c;
                            for (c = 0; c < response.data.result.length; c++) {

                                var activeData = response.data.result[c].IS_ACTIVE;
                                if (activeData == 1) {
                                    activeData = 'Active';
                                } else {
                                    activeData = 'Inactive';
                                }


                                dataService.push({
                                    superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                                    superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                                    tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                                    tradeName: response.data.result[c].TRADE_CATEGORY,
                                    isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                                    isActive: activeData
                                });


                            }

                            console.log(dataService);

                            this.setState({ dataService: dataService });
                            this.setState({ loading: false });
                            //alert(response['success']);
                        }
                        );

                    if (response.data.success) {
                        if (active == 0) {
                            this.props.alert.success("Trade Category Deactive Successfully.");
                        } else {
                            this.props.alert.success("Trade Category Active Successfully.");
                        }
                    } else {
                        this.props.alert.error("Trade Category Action Error.");
                    }
                    ///////////////////

                }
                )

            this.handleCloseDelete();
            //window.location.reload();

            serviceDeleteState = 0;
        } else {
            this.setState({ loading: true });


            if (active == "Active") {
                active = 0;
            } else {
                active = 1;
            }

            const tradeDeleteData = {

                deleteId: tradeId,
                deleteName: deleteTradeName,
                isActive: active,
            }

            axios.post(window.inventoryServer+'/inventory/delete/trade', tradeDeleteData)
                .then(response => {
                    //alert(response);
                    //alert(response['statusText']);
                    ////////////////////////
                    /////table refresh


                    var data = [];
                    //var dataSuperTrade = [];

                    axios.get(window.inventoryServer+'/inventory/get/TradeCategoryView')
                        .then(response => {
                            //alert(response);
                            console.log(response.data.result);

                            var c;
                            for (c = 0; c < response.data.result.length; c++) {

                                var activeData = response.data.result[c].IS_ACTIVE;
                                if (activeData == 1) {
                                    activeData = 'Active';
                                } else {
                                    activeData = 'Inactive';
                                }


                                data.push({
                                    superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                                    superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                                    tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                                    tradeName: response.data.result[c].TRADE_CATEGORY,
                                    isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                                    isActive: activeData
                                });


                            }

                            console.log(data);

                            this.setState({ data: data });
                            this.setState({ loading: false });
                            //alert(response['success']);
                        }
                        );
                    if (response.data.success) {
                        if (active == 0) {
                            this.props.alert.success("Trade Category Deactive Successfully.");
                        } else {
                            this.props.alert.success("Trade Category Active Successfully.");
                        }
                    } else {
                        this.props.alert.error("Trade Category Action Error.");
                    }
                    ///////////////////

                }
                )

            this.handleCloseDelete();
            //window.location.reload();

        }

    };

    //////////////////////////////////////////////////////////
    //--

    ////////////////////////////////////////////////////////
    /// View Funtion


    handleClickViewService = () => {
        serviceViewState = 1;
        this.handleClickView();
    };

    handleClickView = () => {
        this.setState({ view: true });
    };

    handleCloseView = () => {
        this.setState({ view: false });
    };

    stateDelete = {
        canDelete: false
    };



    render() {

        if (this.state.loading) {
            return (
                <Loader />
            );
        } else {

            const { classes } = this.props;
            const { value } = this.state;
            const { openEditContactDialog } = this.props;
            const { canSubmit } = this.state;

            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot,
                        toolbar: classes.layoutToolbar
                    }}

                    contentToolbar={
                        <Tabs
                            value={value}
                            onChange={this.handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            //scrollable
                            scrollButtons="auto"
                            classes={{
                                root: classes.tabsRoot
                            }}
                        >
                            <Tab
                                classes={{
                                    root: classes.tabRoot
                                }}
                                label="Item Trade Category"
                            />
                            <Tab
                                classes={{
                                    root: classes.tabRoot
                                }}
                                label="Service Trade Category"
                            />


                        </Tabs>
                    }
                    content={
                        <div className="p-24 supertrade-form-margin">
                            {value === 0 &&
                                (
                                    <FusePageSimple
                                        classes={{
                                            root: classes.layoutRoot
                                        }}

                                        contentToolbar={
                                            <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">

                                                <div className="flex flex-1 items-center">
                                                    <Hidden lgUp>
                                                        <IconButton
                                                            // onClick={(ev) => pageLayout().toggleLeftSidebar()}
                                                            aria-label="open left sidebar"
                                                        >
                                                            <Icon>menu</Icon>
                                                        </IconButton>
                                                    </Hidden>

                                                    <div className="flex items-center">
                                                        <Icon className="text-32 mr-12 subtitle-color">account_box</Icon>
                                                        <Typography variant="title" className="subtitle-color">Trade Category For Item</Typography>
                                                    </div>
                                                </div>

                                                <div className="flex items-center">
                                                    <Tooltip
                                                        enterDelay={300}
                                                        id="tooltip-controlled"
                                                        leaveDelay={300}
                                                        placement="bottom"
                                                        title="Do you want to Add New ?"
                                                    >
                                                        <Button
                                                            onClick={this.addhandleClickOpen}
                                                            type="submit"
                                                            variant="raised"
                                                            color="secondary"
                                                            className="mx-8 mt-10 pb-15"
                                                            aria-label="Help"
                                                        //disabled={!canSubmit}
                                                        >
                                                            Add New
                    </Button>
                                                    </Tooltip>
                                                    {/* *************** */}


                                                    <Dialog
                                                        open={this.state.add}
                                                        //onClose={this.addhandleClose}
                                                        aria-labelledby="form-dialog-title"
                                                    >
                                                        <DialogTitle id="form-dialog-title">Add New Trade Category</DialogTitle>
                                                        <DialogContent>
                                                            <div >



                                                                <Formsy
                                                                    onValidSubmit={this.onSubmit}
                                                                    onValid={this.enableButton}
                                                                    onInvalid={this.disableButton}
                                                                    ref={(form) => this.form = form}
                                                                    className="flex flex-col justify-center"
                                                                >

                                                                    <SelectFormsy
                                                                        className="my-24 justify-right"
                                                                        name="superTradeSelecter"
                                                                        label="Super Category"
                                                                        value="none"
                                                                        //validations="equals:none"
                                                                        validationError="Must be None"
                                                                    >


                                                                        <MenuItem className="popup-value-size" value="none" ref="superTradeMenu">
                                                                            <em>Please Select</em>
                                                                        </MenuItem>
                                                                        {this.state.dataSuperTrade.map(function (item, i) {
                                                                            return <MenuItem className="popup-value-size" value={item.superTradeIds}>{item.superTradeNames}</MenuItem>;
                                                                        })}

                                                                    </SelectFormsy>

                                                                    <TextFieldFormsy
                                                                        className="my-24 justify-right"
                                                                        type="text"
                                                                        name="tradeName"
                                                                        label="Name"
                                                                        validations={{
                                                                            minLength: 1
                                                                        }}
                                                                        validationErrors={{
                                                                            minLength: 'Min character length is 1'
                                                                        }}
                                                                        validations={{
                                                                            maxLength: 30
                                                                        }}
                                                                        validationErrors={{
                                                                            maxLength: 'Max character length is 30'
                                                                        }}
                                                                        required
                                                                    />
                                                                    <div>
                                                                        <Button
                                                                            type="submit"
                                                                            variant="raised"
                                                                            color="secondary"
                                                                            className="mx-16 mt-16 pb-15"
                                                                            aria-label="Add"
                                                                            disabled={!canSubmit}
                                                                        >
                                                                            Add
                                                                    {/* <Icon className={classes.rightIcon}> send</Icon> */}
                                                                        </Button>
                                                                        <Button className="mx-16 mt-16 pb-15" onClick={this.addhandleClose}   variant="raised" color="primary">
                                                                            Cancel
                                                            </Button></div>

                                                                </Formsy>


                                                            </div>
                                                        </DialogContent>


                                                    </Dialog>
                                                    {/* ///// */}


                                                    {/* <Button
                                                    type="submit"
                                                    variant="raised"
                                                    color="secondary"
                                                    className="mx-8 mt-10 pb-15"
                                                    aria-label="Help"
                                                //disabled={!canSubmit}
                                                >
                                                    Help
                    </Button> */}

                                                </div>
                                            </ div>


                                        }
                                        content={
                                            <div class="flex h-auto ">

                                                <div class="w-full bg-white h-auto m-4">

                                                    <div class="border-0 m-4">
                                                        <ReactTable

                                                            //className={classNames(classes.root, "-striped -highlight")}
                                                            getTrProps={(state, rowInfo, column) => {
                                                                return {
                                                                    className: "cursor-pointer",
                                                                    onClick: (e, handleOriginal) => {
                                                                        if (rowInfo) {
                                                                            //openEditContactDialog(rowInfo.original);
                                                                            //alert('asas');

                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            data={this.state.data}
                                                            TbodyComponent={CustomTbodyComponent}
                                                            columns={[

                                                                {
                                                                    Header: "Super Category Name",
                                                                    accessor: "superTradeName",
                                                                    filterable: true,
                                                                    Cell: row => (
                                                                        <span>
                                                                            <span style={{
                                                                                color: row.original.isActiveSuper === 1 ? '#57d500'
                                                                                    : row.original.isActiveSuper === 0 ? '#ff2e00'
                                                                                        : '#ffbf00',
                                                                                transition: 'all .3s ease'
                                                                            }}>
                                                                                &#x25cf;
                                                                </span> {
                                                                                row.value
                                                                            }
                                                                        </span>
                                                                    )

                                                                },
                                                                {
                                                                    Header: "Trade Category Name",
                                                                    accessor: "tradeName",
                                                                    filterable: true,
                                                                    Cell: row => (
                                                                        <span>
                                                                            <span style={{
                                                                                color: row.original.isActive === 'Active' ? '#57d500'
                                                                                    : row.original.isActive === 'Inactive' ? '#ff2e00'
                                                                                        : '#ffbf00',
                                                                                transition: 'all .3s ease'
                                                                            }}>
                                                                                &#x25cf;
                                                                </span> {
                                                                                row.value
                                                                            }
                                                                        </span>
                                                                    )

                                                                },
                                                                {
                                                                    Header: "Status",
                                                                    accessor: "isActive",
                                                                    filterable: true,
                                                                    show: false

                                                                }
                                                                ,
                                                                {
                                                                    Header: "Action",
                                                                    accessor: "su",
                                                                    width: 128,
                                                                    Cell: row => (

                                                                        row.original.isActive == 'Active' ? (

                                                                            <div className="flex items-center">

                                                                                <Tooltip
                                                                                    enterDelay={300}
                                                                                    id="tooltip-controlled"
                                                                                    leaveDelay={300}
                                                                                    placement="bottom"
                                                                                    title="Do you want to inactive ?"
                                                                                >

                                                                                    <IconButton
                                                                                        className={classes.smaller}
                                                                                        onClick={(e) => {
                                                                                            if (row) {

                                                                                                SelecterSuperTradeName = row.original.superTradeName;
                                                                                                updateTradeId = row.original.tradeId;
                                                                                                updateTradeName = row.original.tradeName;
                                                                                                isActive = row.original.isActive;
                                                                                                // this.setState({ delete: true });
                                                                                                confirmAlert({
                                                                                                    title: 'Confirm to Deactive',
                                                                                                    message: 'Are you sure to do this.',
                                                                                                    buttons: [
                                                                                                        {
                                                                                                            label: 'Yes',
                                                                                                            onClick: () => this.onDelete(updateTradeId, updateTradeName, isActive, 0)
                                                                                                        },
                                                                                                        {
                                                                                                            label: 'No'
                                                                                                        }
                                                                                                    ]
                                                                                                })


                                                                                            }
                                                                                        }}


                                                                                    >
                                                                                        <Icon className="text-green">check_circle</Icon>
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                {/* ///// */}

                                                                                <Dialog
                                                                                    open={this.state.delete}
                                                                                    onClose={this.handleClose}
                                                                                    aria-labelledby="form-dialog-title"
                                                                                >
                                                                                    <DialogTitle id="form-dialog-title">Deactive Trade</DialogTitle>
                                                                                    <DialogContent>

                                                                                        <div>

                                                                                            <Formsy
                                                                                                onValidSubmit={this.onDelete}
                                                                                                onValid={this.enableButtonDelete}
                                                                                                onInvalid={this.disableButtonDelete}
                                                                                                ref={(form) => this.form = form}
                                                                                                className="flex flex-col justify-center"
                                                                                            >

                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="hidden"
                                                                                                    name="deleteTradeId"
                                                                                                    //label="Super Category"
                                                                                                    value={SelecterSuperTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />



                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="text"
                                                                                                    name="deleteTradeName"
                                                                                                    label="Trade Name"
                                                                                                    value={updateTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />

                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="hidden"
                                                                                                    name="isActive"
                                                                                                    // label="Is Active"
                                                                                                    value={isActive}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />

                                                                                                <Typography variant="title">Are You sure?</Typography>


                                                                                                <DialogActions>


                                                                                                    <Button
                                                                                                        type="submit"
                                                                                                        variant="raised"
                                                                                                        color="primary"
                                                                                                        className="mx-auto mt-16 pb-15"
                                                                                                        aria-label="Edit"
                                                                                                    // disabled={!canEdit}
                                                                                                    >
                                                                                                        Deactive
                                            </Button>

                                                                                                    <Button onClick={this.handleCloseDelete}   variant="raised" color="primary">
                                                                                                        Cancel
                                                            </Button>
                                                                                                </DialogActions>
                                                                                            </Formsy>
                                                                                        </div>
                                                                                    </DialogContent>


                                                                                </Dialog>
                                                                                {/* ///// */}
                                                                                <Tooltip
                                                                                    enterDelay={300}
                                                                                    id="tooltip-controlled"
                                                                                    leaveDelay={300}
                                                                                    placement="bottom"
                                                                                    title="Do you want to Edit ?"
                                                                                >
                                                                                    <IconButton
                                                                                        className={classes.smaller}
                                                                                        onClick={(e) => {
                                                                                            if (row) {

                                                                                                SelecterSuperTradeName = row.original.superTradeName;
                                                                                                SelecterSuperTradeId = row.original.superTradeId;
                                                                                                updateTradeId = row.original.tradeId;
                                                                                                updateTradeName = row.original.tradeName;
                                                                                                isActive = row.original.isActive;
                                                                                                this.setState({ edit: true });


                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <Icon className="text-blue">mode_edit</Icon>
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                {/* ///// */}

                                                                                <Dialog
                                                                                    open={this.state.edit}
                                                                                    // onClose={this.handleCloseEdit}
                                                                                    aria-labelledby="form-dialog-title"
                                                                                >
                                                                                    <DialogTitle id="form-dialog-title">Edit Trade Category</DialogTitle>
                                                                                    <DialogContent>

                                                                                        <div>

                                                                                            <Formsy
                                                                                                onValidSubmit={this.onEdit}
                                                                                                onValid={this.enableButtonEdit}
                                                                                                onInvalid={this.disableButtonEdit}
                                                                                                ref={(form) => this.form = form}
                                                                                                className="flex flex-col justify-center"
                                                                                            >

                                                                                                <SelectFormsy
                                                                                                    className="my-16 justify-right"
                                                                                                    name="superTradeSelecter"
                                                                                                    label="Super Category"
                                                                                                    // value="none"
                                                                                                    //validations="equals:none"
                                                                                                    validationError="Must be None"

                                                                                                    value={SelecterSuperTradeId}
                                                                                                // onChange={this.handleChange}

                                                                                                >


                                                                                                    {/* <MenuItem value={SelecterSuperTradeId} ref="superTradeMenu">
                                                                                                <em>{SelecterSuperTradeName}</em>
                                                                                            </MenuItem> */}
                                                                                                    {this.state.dataSuperTrade.map(function (item, i) {
                                                                                                        return <MenuItem className="popup-value-size" value={item.superTradeIds}>{item.superTradeNames}</MenuItem>;
                                                                                                    })}

                                                                                                </SelectFormsy>

                                                                                                {/* <TextFieldFormsy
                                                                                            className="my-8 justify-right"
                                                                                            type="text"
                                                                                            name="editTradeId"
                                                                                            label="Trade ID"
                                                                                            value={updateTradeId}
                                                                                            validations={{
                                                                                                minLength: 1
                                                                                            }}
                                                                                            validationErrors={{
                                                                                                minLength: 'Min character length is 4'
                                                                                            }}
                                                                                            required
                                                                                            disabled={true}
                                                                                        /> */}


                                                                                                <TextFieldFormsy
                                                                                                    className="my-8 justify-right"
                                                                                                    type="text"
                                                                                                    name="editTradeName"
                                                                                                    label="Trade Name"
                                                                                                    value={updateTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                />


                                                                                                <DialogActions>


                                                                                                    <Button
                                                                                                        type="submit"
                                                                                                        variant="raised"
                                                                                                        color="secondary"
                                                                                                        className="mx-16 mt-16 pb-15"
                                                                                                        aria-label="Edit"
                                                                                                    // disabled={!canEdit}
                                                                                                    >
                                                                                                        Edit
                                            </Button>

                                                                                                    <Button className="mx-16 mt-16 pb-15" onClick={this.handleCloseEdit}  variant="raised" color="primary">
                                                                                                        Cancel
                                                            </Button>
                                                                                                </DialogActions>
                                                                                            </Formsy>
                                                                                        </div>
                                                                                    </DialogContent>


                                                                                </Dialog>
                                                                                {/* ///// */}


                                                                                <Tooltip
                                                                                    enterDelay={300}
                                                                                    id="tooltip-controlled"
                                                                                    leaveDelay={300}
                                                                                    placement="bottom"
                                                                                    title="Do you want to View ?"
                                                                                >
                                                                                    <IconButton
                                                                                        className={classes.smaller}
                                                                                        onClick={(e) => {
                                                                                            if (row) {

                                                                                                SelecterSuperTradeName = row.original.superTradeName;
                                                                                                updateTradeId = row.original.tradeId;
                                                                                                updateTradeName = row.original.tradeName;
                                                                                                isActive = row.original.isActive;
                                                                                                this.setState({ view: true });


                                                                                            }
                                                                                        }}


                                                                                    >
                                                                                        <Icon className="text-GREY">visibility</Icon>
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                {/* ///// */}

                                                                                <Dialog
                                                                                    open={this.state.view}
                                                                                    onClose={this.handleCloseView}
                                                                                    aria-labelledby="form-dialog-title"
                                                                                >
                                                                                    <DialogTitle id="form-dialog-title">View Trade Category</DialogTitle>
                                                                                    <DialogContent>

                                                                                        <div>

                                                                                            <Formsy
                                                                                                onValidSubmit={this.onDelete}
                                                                                                //onValid={this.enableButtonDelete}
                                                                                                // onInvalid={this.disableButtonDelete}
                                                                                                ref={(form) => this.form = form}
                                                                                                className="flex flex-col justify-center"
                                                                                            >

                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="text"
                                                                                                    name="deleteTradeId"
                                                                                                    label="Super Category"
                                                                                                    value={SelecterSuperTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />



                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="text"
                                                                                                    name="deleteTradeName"
                                                                                                    label="Trade Name"
                                                                                                    value={updateTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />

                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="text"
                                                                                                    name="isActive"
                                                                                                    label="Is Active"
                                                                                                    value={isActive}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />



                                                                                                <Button onClick={this.handleCloseView}  variant="raised"  color="primary">
                                                                                                    Cancel
                                                            </Button>



                                                                                            </Formsy>
                                                                                        </div>
                                                                                    </DialogContent>


                                                                                </Dialog>

                                                                                {/* ///// */}


                                                                            </div>
                                                                        ) :
                                                                            (
                                                                                <div>
                                                                                    <Tooltip
                                                                                        enterDelay={300}
                                                                                        id="tooltip-controlled"
                                                                                        leaveDelay={300}
                                                                                        placement="bottom"
                                                                                        title="Do you want to Active ?"
                                                                                    >
                                                                                        <IconButton
                                                                                            className={classes.smaller}
                                                                                            onClick={(e) => {
                                                                                                if (row) {

                                                                                                    SelecterSuperTradeName = row.original.superTradeName;
                                                                                                    updateTradeId = row.original.tradeId;
                                                                                                    updateTradeName = row.original.tradeName;
                                                                                                    isActive = row.original.isActive;
                                                                                                    //  this.setState({ delete2: true });

                                                                                                    confirmAlert({
                                                                                                        title: 'Confirm to Activate',
                                                                                                        message: 'Are you sure to do this.',
                                                                                                        buttons: [
                                                                                                            {
                                                                                                                label: 'Yes',
                                                                                                                onClick: () => this.onDelete(updateTradeId, updateTradeName, isActive, 0)
                                                                                                            },
                                                                                                            {
                                                                                                                label: 'No'
                                                                                                            }
                                                                                                        ]
                                                                                                    })

                                                                                                }
                                                                                            }}


                                                                                        >
                                                                                            <Icon className="text-red"  variant="raised" >cancel</Icon>
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                    {/* ///// */}

                                                                                    <Dialog
                                                                                        open={this.state.delete2}
                                                                                        onClose={this.handleClose}
                                                                                        aria-labelledby="form-dialog-title"
                                                                                    >
                                                                                        <DialogTitle id="form-dialog-title">Active Trade</DialogTitle>
                                                                                        <DialogContent>

                                                                                            <div>

                                                                                                <Formsy
                                                                                                    onValidSubmit={this.onDelete}
                                                                                                    onValid={this.enableButtonDelete}
                                                                                                    onInvalid={this.disableButtonDelete}
                                                                                                    ref={(form) => this.form = form}
                                                                                                    className="flex flex-col justify-center"
                                                                                                >

                                                                                                    <TextFieldFormsy
                                                                                                        className="mb-24 mx-20"
                                                                                                        type="hidden"
                                                                                                        name="deleteTradeId"
                                                                                                        // label="Super Category"
                                                                                                        value={SelecterSuperTradeName}
                                                                                                        validations={{
                                                                                                            minLength: 1
                                                                                                        }}
                                                                                                        validationErrors={{
                                                                                                            minLength: 'Min character length is 4'
                                                                                                        }}
                                                                                                        required
                                                                                                        disabled={true}
                                                                                                    />



                                                                                                    <TextFieldFormsy
                                                                                                        className="mb-24 mx-20"
                                                                                                        type="text"
                                                                                                        name="deleteTradeName"
                                                                                                        label="Trade Name"
                                                                                                        value={updateTradeName}
                                                                                                        validations={{
                                                                                                            minLength: 1
                                                                                                        }}
                                                                                                        validationErrors={{
                                                                                                            minLength: 'Min character length is 4'
                                                                                                        }}
                                                                                                        required
                                                                                                        disabled={true}
                                                                                                    />

                                                                                                    <TextFieldFormsy
                                                                                                        className="mb-24 mx-20"
                                                                                                        type="hidden"
                                                                                                        name="isActive"
                                                                                                        //label="Is Active"
                                                                                                        value={isActive}
                                                                                                        validations={{
                                                                                                            minLength: 1
                                                                                                        }}
                                                                                                        validationErrors={{
                                                                                                            minLength: 'Min character length is 4'
                                                                                                        }}
                                                                                                        required
                                                                                                        disabled={true}
                                                                                                    />

                                                                                                    <Typography variant="title">Are You sure?</Typography>


                                                                                                    <DialogActions>


                                                                                                        <Button
                                                                                                            type="submit"
                                                                                                            variant="raised"
                                                                                                            color="primary"
                                                                                                            className="mx-auto mt-16 pb-15"
                                                                                                            aria-label="Edit"
                                                                                                            onClick={this.handleCloseDelete2}
                                                                                                        // disabled={!canEdit}
                                                                                                        >
                                                                                                            Active
                                            </Button>

                                                                                                        <Button onClick={this.handleCloseDelete2}  variant="raised"  color="primary">
                                                                                                            Cancel
                                                            </Button>
                                                                                                    </DialogActions>
                                                                                                </Formsy>
                                                                                            </div>
                                                                                        </DialogContent>


                                                                                    </Dialog>
                                                                                    {/* ///// */}
                                                                                </div>
                                                                            )
                                                                    )
                                                                }

                                                            ]}
                                                            defaultPageSize={10}
                                                            style={{
                                                                height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
                                                            }}
                                                            className="-striped -highlight"
                                                            className="-striped -highlight"
                                                        />
                                                    </div>
                                                </div>



                                            </div>
                                        }
                                    />
                                )}
                            {value === 1 && (
                                <FusePageSimple
                                    classes={{
                                        root: classes.layoutRoot
                                    }}

                                    contentToolbar={
                                        <div className="flex flex-1 flex-col sm:flex-row items-center justify-between p-24">

                                            <div className="flex flex-1 items-center">
                                                <Hidden lgUp>
                                                    <IconButton
                                                        // onClick={(ev) => pageLayout().toggleLeftSidebar()}
                                                        aria-label="open left sidebar"
                                                    >
                                                        <Icon>menu</Icon>
                                                    </IconButton>
                                                </Hidden>

                                                <div className="flex items-center">
                                                    <Icon className="text-32 mr-12 subtitle-color">account_box</Icon>
                                                    <Typography variant="title" className="subtitle-color">Trade Category For Service</Typography>
                                                </div>
                                            </div>

                                            <div className="flex items-center">
                                                <Tooltip
                                                    enterDelay={300}
                                                    id="tooltip-controlled"
                                                    leaveDelay={300}
                                                    placement="bottom"
                                                    title="Do you want to Add New ?"
                                                >
                                                    <Button
                                                        onClick={this.addhandleClickOpenService}
                                                        type="submit"
                                                        variant="raised"
                                                        color="secondary"
                                                        className="mx-8 mt-10 pb-15"
                                                        aria-label="Help"
                                                    //disabled={!canSubmit}
                                                    >
                                                        Add New
            </Button>
                                                </Tooltip>
                                                {/* *************** */}


                                                <Dialog
                                                    open={this.state.add}
                                                    //onClose={this.addhandleClose}
                                                    aria-labelledby="form-dialog-title"
                                                >
                                                    <DialogTitle id="form-dialog-title">Add New Trade Category</DialogTitle>
                                                    <DialogContent>
                                                        <div >



                                                            <Formsy
                                                                onValidSubmit={this.onSubmit}
                                                                onValid={this.enableButton}
                                                                onInvalid={this.disableButton}
                                                                ref={(form) => this.form = form}
                                                                className="flex flex-col justify-center"
                                                            >

                                                                <SelectFormsy
                                                                    className="my-24 justify-right"
                                                                    name="superTradeSelecter"
                                                                    label="Super Category"
                                                                    value="none"
                                                                    //validations="equals:none"
                                                                    validationError="Must be None"
                                                                >


                                                                    <MenuItem className="popup-value-size" value="none" ref="superTradeMenu">
                                                                        <em>Please Select</em>
                                                                    </MenuItem>
                                                                    {this.state.dataSuperTradeService.map(function (item, i) {
                                                                        return <MenuItem className="popup-value-size" value={item.superTradeIds}>{item.superTradeNames}</MenuItem>;
                                                                    })}

                                                                </SelectFormsy>

                                                                <TextFieldFormsy
                                                                    className="my-24 justify-right"
                                                                    type="text"
                                                                    name="tradeName"
                                                                    label="Name"
                                                                    validations={{
                                                                        minLength: 1
                                                                    }}
                                                                    validationErrors={{
                                                                        minLength: 'Min character length is 1'
                                                                    }}
                                                                    validations={{
                                                                        maxLength: 30
                                                                    }}
                                                                    validationErrors={{
                                                                        maxLength: 'Max character length is 30'
                                                                    }}
                                                                    required
                                                                />

                                                                {/* <TextFieldFormsy
                                        className="mb-24 mx-20"
                                        type="text"
                                        name="tradeRemark"
                                        label="Remark"
                                        validations={{
                                            minLength: 4
                                        }}
                                        validationErrors={{
                                            minLength: 'Min character length is 4'
                                        }}
                                        required
                                    /> */}

                                                                {/* <CheckboxFormsy
                                        className="isActive mx-20"
                                        name="isActive"
                                        label="Is Active"
                                        validations="equals:true"
                                        validationError="You need to accept"
                                    /> */}
                                                                <div>
                                                                    <Button
                                                                        type="submit"
                                                                        variant="raised"
                                                                        color="secondary"
                                                                        className="mx-16 mt-16 pb-15"
                                                                        aria-label="Add"
                                                                        disabled={!canSubmit}
                                                                    >
                                                                        Add
                                                            {/* <Icon className={classes.rightIcon}> send</Icon> */}
                                                                    </Button>
                                                                    <Button className="mx-16 mt-16 pb-15" onClick={this.addhandleClose}  variant="raised" color="primary">
                                                                        Cancel
                                                    </Button></div>

                                                            </Formsy>


                                                        </div>
                                                    </DialogContent>


                                                </Dialog>
                                                {/* ///// */}


                                                {/* <Button
                                            type="submit"
                                            variant="raised"
                                            color="secondary"
                                            className="mx-8 mt-10 pb-15"
                                            aria-label="Help"
                                        //disabled={!canSubmit}
                                        >
                                            Help
            </Button> */}

                                            </div>
                                        </ div>


                                    }
                                    content={
                                        <div class="flex h-auto ">

                                            <div class="w-full bg-white h-auto m-4">

                                                <div class="border-0 m-4">
                                                    <ReactTable

                                                        //className={classNames(classes.root, "-striped -highlight")}
                                                        getTrProps={(state, rowInfo, column) => {
                                                            return {
                                                                className: "cursor-pointer",
                                                                onClick: (e, handleOriginal) => {
                                                                    if (rowInfo) {
                                                                        //openEditContactDialog(rowInfo.original);
                                                                        //alert('asas');

                                                                    }
                                                                }
                                                            }
                                                        }}
                                                        data={this.state.dataService}
                                                        TbodyComponent={CustomTbodyComponent}
                                                        columns={[

                                                            {
                                                                Header: "Super Category Name",
                                                                accessor: "superTradeName",
                                                                filterable: true,
                                                                Cell: row => (
                                                                    <span>
                                                                        <span style={{
                                                                            color: row.original.isActiveSuper === 1 ? '#57d500'
                                                                                : row.original.isActiveSuper === 0 ? '#ff2e00'
                                                                                    : '#ffbf00',
                                                                            transition: 'all .3s ease'
                                                                        }}>
                                                                            &#x25cf;
                                                        </span> {
                                                                            row.value
                                                                        }
                                                                    </span>
                                                                )

                                                            },
                                                            {
                                                                Header: "Trade Category Name",
                                                                accessor: "tradeName",
                                                                filterable: true,
                                                                Cell: row => (
                                                                    <span>
                                                                        <span style={{
                                                                            color: row.original.isActive === 'Active' ? '#57d500'
                                                                                : row.original.isActive === 'Inactive' ? '#ff2e00'
                                                                                    : '#ffbf00',
                                                                            transition: 'all .3s ease'
                                                                        }}>
                                                                            &#x25cf;
                                                        </span> {
                                                                            row.value
                                                                        }
                                                                    </span>
                                                                )

                                                            },
                                                            {
                                                                Header: "Status",
                                                                accessor: "isActive",
                                                                filterable: true,
                                                                show: false

                                                            }
                                                            ,
                                                            {
                                                                Header: "Action",
                                                                accessor: "su",
                                                                width: 128,
                                                                Cell: row => (
                                                                    row.original.isActive == 'Active' ? (

                                                                        <div className="flex items-center">

                                                                            <Tooltip
                                                                                enterDelay={300}
                                                                                id="tooltip-controlled"
                                                                                leaveDelay={300}
                                                                                placement="bottom"
                                                                                title="Do you want to inactive ?"
                                                                            >
                                                                                <IconButton
                                                                                    className={classes.smaller}
                                                                                    onClick={(e) => {
                                                                                        if (row) {

                                                                                            SelecterSuperTradeName = row.original.superTradeName;
                                                                                            updateTradeId = row.original.tradeId;
                                                                                            updateTradeName = row.original.tradeName;
                                                                                            isActive = row.original.isActive;
                                                                                            // this.setState({ delete: true });
                                                                                            //this.handleClickDeleteService();

                                                                                            confirmAlert({
                                                                                                title: 'Confirm to Deactivate',
                                                                                                message: 'Are you sure to do this.',
                                                                                                buttons: [
                                                                                                    {
                                                                                                        label: 'Yes',
                                                                                                        onClick: () => this.onDelete(updateTradeId, updateTradeName, isActive, 1)
                                                                                                    },
                                                                                                    {
                                                                                                        label: 'No'
                                                                                                    }
                                                                                                ]
                                                                                            })


                                                                                        }
                                                                                    }}


                                                                                >
                                                                                    <Icon className="text-green">check_circle</Icon>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            {/* ///// */}

                                                                            <Dialog
                                                                                open={this.state.delete}
                                                                                onClose={this.handleClose}
                                                                                aria-labelledby="form-dialog-title"
                                                                            >
                                                                                <DialogTitle id="form-dialog-title">Deactive Trade</DialogTitle>
                                                                                <DialogContent>

                                                                                    <div>

                                                                                        <Formsy
                                                                                            onValidSubmit={this.onDelete}
                                                                                            onValid={this.enableButtonDelete}
                                                                                            onInvalid={this.disableButtonDelete}
                                                                                            ref={(form) => this.form = form}
                                                                                            className="flex flex-col justify-center"
                                                                                        >

                                                                                            <TextFieldFormsy
                                                                                                className="mb-24 mx-20"
                                                                                                type="hidden"
                                                                                                name="deleteTradeId"
                                                                                                //  label="Super Category"
                                                                                                value={SelecterSuperTradeName}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                                disabled={true}
                                                                                            />



                                                                                            <TextFieldFormsy
                                                                                                className="mb-24 mx-20"
                                                                                                type="text"
                                                                                                name="deleteTradeName"
                                                                                                label="Trade Name"
                                                                                                value={updateTradeName}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                                disabled={true}
                                                                                            />

                                                                                            <TextFieldFormsy
                                                                                                className="mb-24 mx-20"
                                                                                                type="hidden"
                                                                                                name="isActive"
                                                                                                // label="Is Active"
                                                                                                value={isActive}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                                disabled={true}
                                                                                            />

                                                                                            <Typography variant="title">Are You sure?</Typography>


                                                                                            <DialogActions>

                                                                                                <Button
                                                                                                    type="submit"
                                                                                                    variant="raised"
                                                                                                    color="primary"
                                                                                                    className="mx-auto mt-16 pb-15"
                                                                                                    aria-label="Edit"
                                                                                                // disabled={!canEdit}
                                                                                                >
                                                                                                    Deactive
                                </Button>

                                                                                                <Button onClick={this.handleCloseDelete}  variant="raised"  color="primary">
                                                                                                    Cancel
                                                </Button>

                                                                                            </DialogActions>
                                                                                        </Formsy>
                                                                                    </div>
                                                                                </DialogContent>


                                                                            </Dialog>
                                                                            {/* ///// */}
                                                                            <Tooltip
                                                                                enterDelay={300}
                                                                                id="tooltip-controlled"
                                                                                leaveDelay={300}
                                                                                placement="bottom"
                                                                                title="Do you want to Edit ?"
                                                                            >
                                                                                <IconButton
                                                                                    className={classes.smaller}
                                                                                    onClick={(e) => {
                                                                                        if (row) {

                                                                                            SelecterSuperTradeName = row.original.superTradeName;
                                                                                            SelecterSuperTradeId = row.original.superTradeId;
                                                                                            updateTradeId = row.original.tradeId;
                                                                                            updateTradeName = row.original.tradeName;
                                                                                            isActive = row.original.isActive;
                                                                                            //this.setState({ edit: true });
                                                                                            this.handleClickOpenEditService();


                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Icon className="text-blue">mode_edit</Icon>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            {/* ///// */}

                                                                            <Dialog
                                                                                open={this.state.edit}
                                                                                // onClose={this.handleCloseEdit}
                                                                                aria-labelledby="form-dialog-title"
                                                                            >
                                                                                <DialogTitle id="form-dialog-title">Edit Trade Category</DialogTitle>
                                                                                <DialogContent>

                                                                                    <div>

                                                                                        <Formsy
                                                                                            onValidSubmit={this.onEdit}
                                                                                            onValid={this.enableButtonEdit}
                                                                                            onInvalid={this.disableButtonEdit}
                                                                                            ref={(form) => this.form = form}
                                                                                            className="flex flex-col justify-center"
                                                                                        >

                                                                                            <SelectFormsy
                                                                                                className="my-24 justify-right"
                                                                                                name="superTradeSelecter"
                                                                                                label="Super Category"
                                                                                                // value="none"
                                                                                                //validations="equals:none"
                                                                                                validationError="Must be None"

                                                                                                value={SelecterSuperTradeId}
                                                                                            // onChange={this.handleChange}

                                                                                            >


                                                                                                {/* <MenuItem value={SelecterSuperTradeId} ref="superTradeMenu">
                                                                                                    <em>{SelecterSuperTradeName}</em>
                                                                                                </MenuItem> */}
                                                                                                {this.state.dataSuperTradeService.map(function (item, i) {
                                                                                                    return <MenuItem className="popup-value-size" value={item.superTradeIds}>{item.superTradeNames}</MenuItem>;
                                                                                                })}

                                                                                            </SelectFormsy>

                                                                                            {/* <TextFieldFormsy
                                                                                className="my-8 justify-right"
                                                                                type="text"
                                                                                name="editTradeId"
                                                                                label="Trade ID"
                                                                                value={updateTradeId}
                                                                                validations={{
                                                                                    minLength: 1
                                                                                }}
                                                                                validationErrors={{
                                                                                    minLength: 'Min character length is 4'
                                                                                }}
                                                                                required
                                                                                disabled={true}
                                                                            /> */}




                                                                                            <TextFieldFormsy
                                                                                                className="my-8 justify-right"
                                                                                                type="text"
                                                                                                name="editTradeName"
                                                                                                label="Trade Name"
                                                                                                value={updateTradeName}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                            />


                                                                                            <DialogActions>

                                                                                                <div>
                                                                                                    <Button
                                                                                                        type="submit"
                                                                                                        variant="raised"
                                                                                                        color="secondary"
                                                                                                        className="mx-16 mt-16 pb-15"
                                                                                                        aria-label="Edit"
                                                                                                    // disabled={!canEdit}
                                                                                                    >
                                                                                                        Edit
                                </Button>

                                                                                                    <Button className="mx-16 mt-16 pb-15" onClick={this.handleCloseEdit} variant="raised" color="primary">
                                                                                                        Cancel
                                                </Button></div>
                                                                                            </DialogActions>
                                                                                        </Formsy>
                                                                                    </div>
                                                                                </DialogContent>


                                                                            </Dialog>
                                                                            {/* ///// */}
                                                                            <Tooltip
                                                                                enterDelay={300}
                                                                                id="tooltip-controlled"
                                                                                leaveDelay={300}
                                                                                placement="bottom"
                                                                                title="Do you want to Active ?"
                                                                            >
                                                                                <IconButton
                                                                                    className={classes.smaller}
                                                                                    onClick={(e) => {
                                                                                        if (row) {

                                                                                            SelecterSuperTradeName = row.original.superTradeName;
                                                                                            updateTradeId = row.original.tradeId;
                                                                                            updateTradeName = row.original.tradeName;
                                                                                            isActive = row.original.isActive;
                                                                                            //this.setState({ view: true });
                                                                                            this.handleClickViewService();

                                                                                        }
                                                                                    }}


                                                                                >
                                                                                    <Icon className="text-GREY">visibility</Icon>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            {/* ///// */}

                                                                            <Dialog
                                                                                open={this.state.view}
                                                                                onClose={this.handleCloseView}
                                                                                aria-labelledby="form-dialog-title"
                                                                            >
                                                                                <DialogTitle id="form-dialog-title">View Trade Category</DialogTitle>
                                                                                <DialogContent>

                                                                                    <div>

                                                                                        <Formsy
                                                                                            onValidSubmit={this.onDelete}
                                                                                            //onValid={this.enableButtonDelete}
                                                                                            // onInvalid={this.disableButtonDelete}
                                                                                            ref={(form) => this.form = form}
                                                                                            className="flex flex-col justify-center"
                                                                                        >

                                                                                            <TextFieldFormsy
                                                                                                className="mb-24 mx-20"
                                                                                                type="text"
                                                                                                name="deleteTradeId"
                                                                                                label="Super Category"
                                                                                                value={SelecterSuperTradeName}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                                disabled={true}
                                                                                            />



                                                                                            <TextFieldFormsy
                                                                                                className="mb-24 mx-20"
                                                                                                type="text"
                                                                                                name="deleteTradeName"
                                                                                                label="Trade Name"
                                                                                                value={updateTradeName}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                                disabled={true}
                                                                                            />

                                                                                            <TextFieldFormsy
                                                                                                className="mb-24 mx-20"
                                                                                                type="text"
                                                                                                name="isActive"
                                                                                                label="Is Active"
                                                                                                value={isActive}
                                                                                                validations={{
                                                                                                    minLength: 1
                                                                                                }}
                                                                                                validationErrors={{
                                                                                                    minLength: 'Min character length is 4'
                                                                                                }}
                                                                                                required
                                                                                                disabled={true}
                                                                                            />





                                                                                            <Button onClick={this.handleCloseView}  variant="raised"  color="primary">
                                                                                                Cancel
                                                </Button>



                                                                                        </Formsy>
                                                                                    </div>
                                                                                </DialogContent>


                                                                            </Dialog>

                                                                            {/* ///// */}


                                                                        </div>
                                                                    ) : (
                                                                            <div>

                                                                                {/* ///// */}

                                                                                <Tooltip
                                                                                    enterDelay={300}
                                                                                    id="tooltip-controlled"
                                                                                    leaveDelay={300}
                                                                                    placement="bottom"
                                                                                    title="Do you want to Active ?"
                                                                                >
                                                                                    <IconButton
                                                                                        className={classes.smaller}
                                                                                        onClick={(e) => {
                                                                                            if (row) {

                                                                                                SelecterSuperTradeName = row.original.superTradeName;
                                                                                                updateTradeId = row.original.tradeId;
                                                                                                updateTradeName = row.original.tradeName;
                                                                                                isActive = row.original.isActive;
                                                                                                // this.setState({ delete: true });
                                                                                                // this.handleClickDeleteService();

                                                                                                confirmAlert({
                                                                                                    title: 'Confirm to Activate',
                                                                                                    message: 'Are you sure to do this.',
                                                                                                    buttons: [
                                                                                                        {
                                                                                                            label: 'Yes',
                                                                                                            onClick: () => this.onDelete(updateTradeId, updateTradeName, isActive, 1)
                                                                                                        },
                                                                                                        {
                                                                                                            label: 'No'
                                                                                                        }
                                                                                                    ]
                                                                                                })


                                                                                            }
                                                                                        }}


                                                                                    >
                                                                                        <Icon className="text-red"  variant="raised" >cancel</Icon>
                                                                                    </IconButton>
                                                                                </Tooltip>

                                                                                {/* ///// */}

                                                                                <Dialog
                                                                                    open={this.state.delete2}
                                                                                    onClose={this.handleClose}
                                                                                    aria-labelledby="form-dialog-title"
                                                                                >
                                                                                    <DialogTitle id="form-dialog-title">Active Trade</DialogTitle>
                                                                                    <DialogContent>

                                                                                        <div>

                                                                                            <Formsy
                                                                                                onValidSubmit={this.onDelete}
                                                                                                onValid={this.enableButtonDelete}
                                                                                                onInvalid={this.disableButtonDelete}
                                                                                                ref={(form) => this.form = form}
                                                                                                className="flex flex-col justify-center"
                                                                                            >

                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="hidden"
                                                                                                    name="deleteTradeId"
                                                                                                    //label="Super Category"
                                                                                                    value={SelecterSuperTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />



                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="text"
                                                                                                    name="deleteTradeName"
                                                                                                    label="Trade Name"
                                                                                                    value={updateTradeName}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />

                                                                                                <TextFieldFormsy
                                                                                                    className="mb-24 mx-20"
                                                                                                    type="hidden"
                                                                                                    name="isActive"
                                                                                                    // label="Is Active"
                                                                                                    value={isActive}
                                                                                                    validations={{
                                                                                                        minLength: 1
                                                                                                    }}
                                                                                                    validationErrors={{
                                                                                                        minLength: 'Min character length is 4'
                                                                                                    }}
                                                                                                    required
                                                                                                    disabled={true}
                                                                                                />

                                                                                                <Typography variant="title">Are You sure?</Typography>


                                                                                                <DialogActions>


                                                                                                    <Button
                                                                                                        type="submit"
                                                                                                        variant="raised"
                                                                                                        color="primary"
                                                                                                        className="mx-auto mt-16 pb-15"
                                                                                                        aria-label="Edit"
                                                                                                        onClick={this.handleCloseDelete2}
                                                                                                    // disabled={!canEdit}
                                                                                                    >
                                                                                                        Active
                                </Button>

                                                                                                    <Button onClick={this.handleCloseDelete2}  variant="raised"  color="primary">
                                                                                                        Cancel
                                                </Button>
                                                                                                </DialogActions>
                                                                                            </Formsy>
                                                                                        </div>
                                                                                    </DialogContent>


                                                                                </Dialog>
                                                                                {/* ///// */}

                                                                            </div>
                                                                        )

                                                                )
                                                            }

                                                        ]}
                                                        defaultPageSize={10}
                                                        style={{
                                                            height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
                                                        }}
                                                        className="-striped -highlight"
                                                        className="-striped -highlight"
                                                    />
                                                </div>
                                            </div>



                                        </div>
                                    }
                                />
                            )}

                        </div>
                    }
                />
            )
        }
    };

    componentWillMount() {

        var data = [];
        var dataService = [];
        var dataSuperTrade = [];
        var dataSuperTradeService = [];

        axios.get(window.inventoryServer+'/inventory/get/TradeCategoryView')
            .then(response => {
                //alert(response);
                console.log(response.data.result);

                var c;
                for (c = 0; c < response.data.result.length; c++) {

                    var activeData = response.data.result[c].IS_ACTIVE;
                    if (activeData == 1) {
                        activeData = 'Active';
                    } else {
                        activeData = 'Inactive';
                    }


                    data.push({
                        superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                        superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                        tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                        tradeName: response.data.result[c].TRADE_CATEGORY,
                        isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                        isActive: activeData
                    });


                }

                console.log(data);

                this.setState({ data: data });

                //alert(response['success']);
            }
            );

        axios.get(window.inventoryServer+'/inventory/get/SuperTradeCategory')
            .then(response => {
                console.log(response.data.result);

                var c;
                for (c = 0; c < response.data.result.length; c++) {


                    // var activeData = response.dataSuperTrade.result[c].IS_ACTIVE;
                    // if (activeData == 1) {
                    //     activeData = 'Active';
                    // } else {
                    //     activeData = 'Inactive';
                    // }

                    dataSuperTrade.push({
                        superTradeIds: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                        superTradeNames: response.data.result[c].SUPER_TRADE_CATEGORY,
                        // tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                        // tradeName: response.data.result[c].TRADE_CATEGORY,
                        // isActive: activeData
                    });


                }

                console.log(dataSuperTrade);

                this.setState({ dataSuperTrade: dataSuperTrade });

                //alert(response['success']);
            }
            );

        ////////////************************ */

        axios.get(window.inventoryServer+'/inventory/get/TradeCategoryViewService')
            .then(response => {
                //alert(response);
                console.log(response.data.result);

                var c;
                for (c = 0; c < response.data.result.length; c++) {

                    var activeData = response.data.result[c].IS_ACTIVE;
                    if (activeData == 1) {
                        activeData = 'Active';
                    } else {
                        activeData = 'Inactive';
                    }


                    dataService.push({
                        superTradeId: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                        superTradeName: response.data.result[c].SUPER_TRADE_CATEGORY,
                        tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                        tradeName: response.data.result[c].TRADE_CATEGORY,
                        isActiveSuper: response.data.result[c].IS_ACTIVE_SUPER,
                        isActive: activeData
                    });


                }

                console.log(dataService);

                this.setState({ dataService: dataService });

                //alert(response['success']);
            }
            );

        axios.get(window.inventoryServer+'/inventory/get/SuperTradeCategoryService')
            .then(response => {
                console.log(response.data.result);

                var c;
                for (c = 0; c < response.data.result.length; c++) {


                    // var activeData = response.dataSuperTrade.result[c].IS_ACTIVE;
                    // if (activeData == 1) {
                    //     activeData = 'Active';
                    // } else {
                    //     activeData = 'Inactive';
                    // }

                    dataSuperTradeService.push({
                        superTradeIds: JSON.stringify(response.data.result[c].ID_SUPER_TRADE_CATEGORY),
                        superTradeNames: response.data.result[c].SUPER_TRADE_CATEGORY,
                        // tradeId: JSON.stringify(response.data.result[c].ID_TRADE_CATEGORY),
                        // tradeName: response.data.result[c].TRADE_CATEGORY,
                        // isActive: activeData
                    });


                }

                console.log(dataSuperTradeService);

                this.setState({ dataSuperTradeService: dataSuperTradeService });
                this.setState({ loading: false });
                //alert(response['success']);
            }

            );
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(SimpleTabbedSample));


// WEBPACK FOOTER //
// ./src/main/content/inventory/tradeCategory/TradeCategory.js